<template>
  <div :class="containerClass" @click="onWrapperClick">
    <the-panel-top-bar @menu-toggle="onMenuToggle" />
    <transition name="layout-sidebar">
      <div
        v-show="isSidebarVisible()"
        class="layout-sidebar layout-sidebar-light"
        @click="onSidebarClick"
      >
        <div class="layout-logo">
          <router-link :to="{ name: 'dashboard' }">
            <img alt="Herta security" src="/assets/images/logo-profile.png" />
          </router-link>
        </div>
        <the-panel-profile />
        <the-panel-menu :model="menu" @menuitem-click="onMenuItemClick" />
      </div>
    </transition>
    <div class="layout-main">
      <panel />
    </div>
    <the-panel-footer />
  </div>
</template>

<script>
import ThePanelFooter from "../../components/ThePanelFooter";
import ThePanelMenu from "../../components/ThePanelMenu";
import ThePanelProfile from "../../components/ThePanelProfile";
import ThePanelTopBar from "../../components/ThePanelTopBar";
import Panel from "./Panel";

export default {
  name: "Layout",
  components: {
    Panel,
    ThePanelMenu,
    ThePanelProfile,
    ThePanelTopBar,
    ThePanelFooter,
  },
  data() {
    return {
      layoutMode: "static",
      layoutColorMode: "light",
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      menu: [],
    };
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
          "p-input-filled": this.$appState.inputStyle === "filled",
          "p-ripple-disabled": this.$primevue.ripple === false,
        },
      ];
    },
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
  },
  created() {
    this.menu = [
      {
        label: this.$i18n.t("section.dashboard"),
        icon: "pi pi-fw pi-home",
        to: { name: "dashboard" },
      },
      {
        label: this.$i18n.t("section.customer"),
        icon: "pi pi-fw pi-user",
        items: [
          {
            label: this.$i18n.t("section.customer_new"),
            icon: "pi pi-fw pi-plus-circle",
            to: { name: "customer-new" },
          },
          {
            label: this.$i18n.t("section.customers"),
            icon: "pi pi-fw pi-clone",
            to: { name: "customers" },
          },
        ],
      },
    ];
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  methods: {
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += ` ${className}`;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(`(^|\\b)${className.split(" ").join("|")}(\\b|$)`, "gi"),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
        else return true;
      } else {
        return true;
      }
    },
  },
};
</script>
